const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/notifications/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { AREA_FILTERS } from '@tempo-io/notification-dto';
import { z } from 'zod';
import { TIME_RANGE_FILTERS } from '@/lib/api/notifications/notificationsApi';
import i18n from '@/lib/translations/i18n';
export const Route = createFileRoute('/(app)/org/$org/notifications/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: z.object({
    view: z.enum(['inbox', 'unread']).catch('inbox'),
    area: z.enum(AREA_FILTERS).catch('all'),
    timeRange: z.enum(TIME_RANGE_FILTERS).catch('all'),
    customFrom: z.string().datetime().optional().catch(undefined),
    customTo: z.string().datetime().optional().catch(undefined)
  }),
  loader: (): LoaderData => ({
    crumb: i18n.t($ => $.notifications.inbox.title)
  }),
  staticData: {
    hideChrome: true
  }
});